export default {
    announcement: 'MyFreeCams Announcement: ',
    reconnectAgain: 'Reconnect Again',
    reconnectCancelled: 'Reconnect Cancelled',
    cancel: 'Cancel',
    disconnectWarning: 'Reconnecting to MyFreeCams',
    ifProblemPersists: 'if this problem persists.',
    loadingNotice: 'Things seem to be taking longer than usual...',
    clickHereToReload: 'Click Here to Reload',
    messages: {
        ignoredUserWarning: `Warning: You will not receive any response, because you are currently ignoring this user.`,
        offlineWarning: `This user is offline and will receive your message next time they login!`,
    },
    pleaseGiveUsAMomentWhile:
        'Please, give us a moment while we retrieve your data',
    refresh_now: 'Refresh Now',
    viewChatArchives: 'view Chat Archives',
    viewMyNotes: 'view My Notes',
}
